
import {
    Card,
    Col,
    Row,
    Button,
    Modal,
    Form
} from "react-bootstrap";
import ParseBooking from '../../../parse-booking';
import React, { useState} from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import PhoneInput from 'react-phone-input-2'

export default function TimeCard(props) {
    const times = props.times;
    const {handleSubmit} = useForm();
    const [show, setShow] = useState(false);
    const [phone, setPhone] = useState('');
    const [bookingTime, setBookingTime] = useState('');
    const [bookingData, setbookingData] = useState({});
    const handleClose = () => setShow(false);
    let history = useHistory();

    const onSubmit = async () => {
        let data = bookingData;
        console.log(phone);
        data.customer_phone = phone;
        console.log(data)
        history.push({
          pathname: '/booking/register',
          state: { bookingData: data }
        });
    }

    const bookTime = (time) => {
        console.log(time)
        const currentBookingTime = ParseBooking(time, 'Your booking is for ', ' at ' + time.clinic_name);
        setbookingData(time)
        setBookingTime(currentBookingTime)
        console.log(time)
        setShow(true);
      };

      return (
        <div>
        <Card>
              <Card.Header>Find the lowest prices and the best service</Card.Header>
              <Card.Body>
                  <Card.Text>
                  Here is the definitive list of times available for booking and their prices. 
                  These dentists have received great reviews from customers and are currently accepting new patients. 
                  Schedule your appointment today!
                  </Card.Text>
              </Card.Body>
        </Card>
        {times.map((time) => (
        <Card key={time._id} className="card my-2">
            <Card.Body>
                <Row xs={12} md={12} lg={12}>
                    <Col xs={12} md={6} lg={4}>
                        <h6>{time.title}</h6>
                        <Card.Text>
                                {ParseBooking(time)}
                        </Card.Text>
                        </Col>

                        <Col xs={12} md={6} lg={4}>
                            <h6>{time.clinic_name}</h6>
                            <Card.Text>
                                    {time.clinic_adress} 
                            </Card.Text>
                        </Col>
                        <Col xs={12} md={6} lg={2}>
                            {time.campaign_price === -1 &&
                                <h4 >
                                        {time.price} AED
                                </h4>
                            }
                            {time.campaign_price !== -1 &&
                                <>
                                <h3 className="text-danger mb-0">
                                        {time.campaign_price} AED
                                </h3>
                                <Card.Text>
                                    <s>
                                        {time.price} AED
                                    </s>
                                </Card.Text>
                                </>
                            }

                        </Col>
                        <Col xs={12} md={6} lg={2}>
                        <Button
                            className="float-right"
                            variant="info"
                            onClick={() => bookTime(time)}
                            >
                            Book Now
                        </Button>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
          ))}
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Book time</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{bookingTime}</p>
            {/*add pattern to the Form.Control below pattern='^(?:\+971|00971|0)(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$' */}
            <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group controlId="phone">
                <Form.Label>Phone Number</Form.Label>
                <PhoneInput 
                    required
                    // pattern='^(?:\+971|00971|0)(?:2|3|4|6|7|9|50|51|52|55|56)[0-9]{7}$'
                    className='w-100'
                    // localization={ae}
                    country={'ae'}
                    placeholder="Please provide your phone number" 
                    value={phone}
                    onChange={input => setPhone( input )}
                />
                </Form.Group>
            <Button variant="primary" type="submit">
                Next
            </Button>
            </Form>
          </Modal.Body>
          </Modal>

        </div>
      );
  }
  
